import api from './Axios'; // Uses your existing configured Axios instance

// Define the shape of the filters matching your backend DTO
export interface GetExpertsFilterParams {
  search?: string;
  category?: string;
  subCategory?: string;
  minRating?: number;
  minExperience?: number;
  sortBy?: 'price' | 'rating' | 'experience';
  sortOrder?: 'ASC' | 'DESC';
}


const normalizeSearch = (value?: string): string | undefined => {
  if (!value) return undefined;

  const normalized = value
    .replace(/[-_']/g, ' ')              // Treat -, _, ' as spaces
    .replace(/[^\p{L}\p{N}\s]/gu, '')    // Remove punctuation
    .trim()                             // Remove leading/trailing spaces
    .replace(/\s+/g, ' ');              // Collapse multiple spaces

  return normalized || undefined;
};
export const expertListApi = {
  // 1. Fetch the filtered list of experts
  getExpertsList: async (params: GetExpertsFilterParams) => {
  const response = await api.get('/api/experts/list', {
  params: {
    ...params,
    search: normalizeSearch(params.search),
  },
});
    return response.data;
  },

  // 2. Fetch a single expert's public card details
  getExpertCard: async (id: string) => {
    const response = await api.get(`/api/experts/${id}/expertCard`);
    return response.data;
  },

  // 3. Fetch an expert's stats
  getExpertStats: async (id: string) => {
    const response = await api.get(`/api/experts/${id}/stats`);
    return response.data;
  }
};